import { axiosClient } from '../axiosInstance';
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

/************ CREATE **************/
// Create a new section
export const createSection = async (newSection) => {
  try {
    console.log("createSection payload:", newSection);
    const response = await axiosClient.post('secure/superior_admin/section', newSection);
    toast(response.data.msg || "Section created successfully");
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to create section";
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }
};

/************* READ ***************/
// Fetch a single section by ID
export const fetchSection = async (id) => {
  const { data } = await axiosClient.get(`secure/superior_admin/section/${id}`);
  return data;
};

// Fetch all sections
export const fetchSections = async () => {
  const { data } = await axiosClient.get('secure/superior_admin/section');
  return data;
};

/************ UPDATE **************/
export const updateSection = async ({ id, section }) => {
  try {
    const response = await axiosClient.patch(`secure/superior_admin/sections_update/${id}`, { section });
    toast(response.data.msg || "Section updated successfully");
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to update section";
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }
};

// Hook for updating section
export const UpdateSection = () => {
  const queryClient = useQueryClient();
  return useMutation(updateSection, {
    onSuccess: () => {
      queryClient.invalidateQueries('fetchSection');
    }
  });
};

/************ DELETE **************/
// Delete a section
 const deleteSection = async ({id,section}) => {
  const data = {sectionName:section}
  await axiosClient.patch(`secure/superior_admin/section_delete/${id}`,{data}).then((res) => {
    toast(res.data.msg);
  });
};
export const DeleteSection = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteSection, {
    onSuccess: () => {
      queryClient.invalidateQueries('fetchSection');
    }
  });
};